// const API_BASE_PATH = process.env.VUE_APP_API_BASE_PATH
const API_BASE_PATH = window.config.VUE_APP_API_BASE_PATH
export default{
  'login': `${API_BASE_PATH}api/user/v1/login/alfredPoint`,
  'monthlyStat': `${API_BASE_PATH}api/orders/v1/alfredpoint/monthlyStat`,
  'dailyStat': `${API_BASE_PATH}api/orders/v1/alfredpoint/dailyStat`,
  'queryOrders': `${API_BASE_PATH}api/orders/v1/alfredpoint/queryOrders`,
  'orderDetail': `${API_BASE_PATH}api/orders/v1/alfredpoint/detail/`,
  'updateOrderNote': `${API_BASE_PATH}api/orders/v1/updateOrderNote`,
  'logistic': `${API_BASE_PATH}api/orders/v1/alfredpoint/logistics`,
  'logo': `${API_BASE_PATH}api/file/v1/preview/`,
  'parcel': `${API_BASE_PATH}api/orders/v1/alfredpoint/parcel/`,
  'collectingPointStoreExpress': `${API_BASE_PATH}api/orders/v1/alfredpoint/collectingPointStoreExpress`,
  'pinCode': `${API_BASE_PATH}api/orders/v1/alfredpoint/checkPinCode`,
  'collectingPointTakeExpress': `${API_BASE_PATH}api/orders/v1/alfredpoint/collectingPointTakeExpress`,
  'accountInfo': `${API_BASE_PATH}api/orders/v1/alfredpoint/accountInfo`,
  'siteDetail': `${API_BASE_PATH}api/locker/v1/detail/`,
  'merchantTakeExpress': `${API_BASE_PATH}api/orders/v1/alfredpoint/merchantTakeExpress`,
  'collectExpiredExpress': `${API_BASE_PATH}api/orders/v1/alfredpoint/collectExpiredExpress`,
  'updateProfile': `${API_BASE_PATH}api/locker/v1/updateProfile`,
  'queryLogs': `${API_BASE_PATH}api/orders/v1/alfredpoint/queryLogs`,
  'verifyCustomer': `${API_BASE_PATH}api/orders/v1/alfredpoint/verifyCustomer`
}



// WEBPACK FOOTER //
// ./src/assets/js/api.js